module.exports = __webpack_public_path__ + "static/img/101114.ecaa1fa1.png";